@if (this.loader.getLoading()) {
  <app-loader></app-loader>
}
<!--
  Lien d'evitement et repere principal : cet ecran est reste hors du perimetre
  qui a traite /login et /reset-password, alors qu'il est tout aussi PUBLIC.
-->
<app-lien-evitement />

<!--
  `<main>` et non `<div>` : la classe porte toujours le style, la balise apporte
  le repere (RGAA 12.6). `tabindex="-1"` la rend focalisable par programme sans
  l'inserer dans l'ordre de tabulation.
-->
<main
  class="reset-password-container dflex aic jcc"
  id="contenu-principal"
  tabindex="-1"
>
  @if (isDefined(isTokenValid) && isTokenValid && !isPassReseted) {
    <img src="/assets/images/reset-password-left.svg" alt="" />
    <form class="reset-password-form" [formGroup]="formGroup">
      <h1 class="h2">{{ 'PROFILE.NEW_PASSWORD' | translate }}</h1>
      <span>{{ 'LOGIN.FORM.PASSWORD.NEW_PASSWORD_TEXT' | translate }}</span>
      <div>
        <label for="password" class="fs12"
          >{{ 'PROFILE.NEW_PASSWORD' | translate }} *:</label
        >
        <app-string-field
          placeholder="exemple@exemple.com"
          controlName="password"
          controlId="password"
          type="password"
          autocomplete="new-password"
          [required]="true"
          [submitted]="submitted"
          [formGroup]="formGroup"
        ></app-string-field>
      </div>
      <div class="progress-bar-container">
        <div
          class="progress-bar"
          [style.width.%]="strengthPercent"
          [style.background]="strengthColor"
        ></div>
      </div>
      <div class="password-rules">
        <div>
          <span
            [class.valid]="passwordRules.minLength"
            class="material-symbols-rounded mini-icon"
            aria-hidden="true"
          >
            {{ passwordRules.minLength ? 'check' : '' }}
          </span>
          {{ 'LOGIN.FORM.PASSWORD.TEN_CHARS' | translate }}
          <span class="visually-hidden">{{
            (passwordRules.minLength
              ? 'LOGIN.FORM.PASSWORD.RULE_MET'
              : 'LOGIN.FORM.PASSWORD.RULE_UNMET'
            ) | translate
          }}</span>
        </div>

        <div>
          <span
            [class.valid]="passwordRules.uppercase"
            class="material-symbols-rounded mini-icon"
            aria-hidden="true"
          >
            {{ passwordRules.uppercase ? 'check' : '' }}
          </span>
          {{ 'LOGIN.FORM.PASSWORD.ONE_UPPERCASE' | translate }}
          <span class="visually-hidden">{{
            (passwordRules.uppercase
              ? 'LOGIN.FORM.PASSWORD.RULE_MET'
              : 'LOGIN.FORM.PASSWORD.RULE_UNMET'
            ) | translate
          }}</span>
        </div>

        <div>
          <span
            [class.valid]="passwordRules.lowercase"
            class="material-symbols-rounded mini-icon"
            aria-hidden="true"
          >
            {{ passwordRules.lowercase ? 'check' : '' }}
          </span>
          {{ 'LOGIN.FORM.PASSWORD.ONE_LOWERCASE' | translate }}
          <span class="visually-hidden">{{
            (passwordRules.lowercase
              ? 'LOGIN.FORM.PASSWORD.RULE_MET'
              : 'LOGIN.FORM.PASSWORD.RULE_UNMET'
            ) | translate
          }}</span>
        </div>

        <div>
          <span
            [class.valid]="passwordRules.numberOrSpecial"
            class="material-symbols-rounded mini-icon"
            aria-hidden="true"
          >
            {{ passwordRules.numberOrSpecial ? 'check' : '' }}
          </span>
          {{ 'LOGIN.FORM.PASSWORD.ONE_NUMBER_OR_SPECIAL' | translate }}
          <span class="visually-hidden">{{
            (passwordRules.numberOrSpecial
              ? 'LOGIN.FORM.PASSWORD.RULE_MET'
              : 'LOGIN.FORM.PASSWORD.RULE_UNMET'
            ) | translate
          }}</span>
        </div>
      </div>

      <div class="mt-1em">
        <label for="confirmPassword" class="fs12"
          >{{ 'PROFILE.CONFIRM_PASSWORD' | translate }} *:</label
        >
        <app-string-field
          placeholder="exemple@exemple.com"
          controlName="confirmPassword"
          controlId="confirmPassword"
          type="password"
          autocomplete="new-password"
          [required]="true"
          [submitted]="submitted"
          [formGroup]="formGroup"
        ></app-string-field>
      </div>

      <!-- Erreurs CROISÉES de la confirmation (concordance, erreur serveur) :
           elles ne viennent pas d'`app-string-field` (qui ne connaît pas ces
           clés), on les annonce donc ici par `role="alert"` (RGAA 11.10). -->
      @if (
        this.formGroup.get('confirmPassword')?.errors?.['mismatch'] ||
        this.formGroup.get('confirmPassword')?.errors?.['form_error']
      ) {
        <div role="alert">
          @if (this.formGroup.get('confirmPassword')?.errors?.['mismatch']) {
            <div class="hub-field__error">
              {{ 'PROFILE.ERRORS.PASSWORDS_NOT_MATCH' | translate }}
            </div>
          }
          @if (this.formGroup.get('confirmPassword')?.errors?.['form_error']) {
            <div class="hub-field__error">
              {{
                this.formGroup.get('confirmPassword')?.errors?.['form_error']
              }}
            </div>
          }
        </div>
      }
      <div class="btn-cont dflex jcfe">
        <button
          class="hub-button hub-button--primary hub-button--large"
          (click)="onSubmit()"
        >
          {{ 'BUTTON.SAVE' | translate }}
        </button>
      </div>
    </form>
  } @else if (isPassReseted) {
    <div class="dflex fdc aic jcc">
      <img src="/assets/images/successful-password-reset.svg" alt="" />
      <div class="mail-sent-cont">
        <span
          class="material-symbols-rounded icon success-icon"
          aria-hidden="true"
          >check</span
        >
        <h1 class="h2">
          {{ 'DASHBOARD.OBJECTIVE.TITLE_SUCCESS' | translate }} !
        </h1>
        <p>
          {{ 'LOGIN.FORM.PASSWORD.UPDATED' | translate }}
        </p>
      </div>
      <a
        routerLink="/login"
        class="hub-button hub-button--primary hub-button--large"
      >
        {{ 'BUTTON.CONTINUE' | translate }}
      </a>
    </div>
  } @else if (isDefined(isTokenValid) && !isTokenValid) {
    <div class="dflex fdc aic jcc">
      <img src="/assets/images/expired-password-reset-link.svg" alt="" />
      <div class="mail-sent-cont">
        <span class="material-symbols-rounded icon" aria-hidden="true"
          >warning</span
        >
        <h1 class="h2">
          {{ 'LOGIN.FORM.PASSWORD.EXPIRED_LINK' | translate }} !
        </h1>
        <p>
          {{ 'LOGIN.FORM.PASSWORD.EXPIRED_LINK_TEXT' | translate }}
          <a routerLink="/reset-password">
            {{ 'LOGIN.FORM.PASSWORD.EXPIRED_LINK_HERE' | translate }}
          </a>
        </p>
      </div>
    </div>
  }
</main>
